import { toRoutePath } from './namedRoutes';
import routes from '../../routes';

export const getNamedPath = name => toRoutePath(routes, name);
